(function () {
    'use strict';

    angular
        .module('core.services')
        .service('CompanyConsultantService', CompanyConsultantService)

    /** @ngInject */
    function CompanyConsultantService(HttpService) {
        const CompanyConsultantService = {
            post,
            deleteData
        }

        return CompanyConsultantService;

        function post(companyConsultantData) {
            return HttpService.post('/companies/consultants', companyConsultantData);
        }

        function deleteData(companyConsultantId) {
            return HttpService.delete(`/companies/consultants/${companyConsultantId}`);
        }
    }
}());